export enum SupplyAccountType {
  PrivateSupply = "PrivateSupply",
  BusinessSupply = "BusinessSupply",
  ThreePLSupply = "ThreePLSupply"
}
